export default function stringMerge(str1, str2, separator = '') {
  const s1 = str1?.toString().trim();
  const s2 = str2?.toString().trim();

  const hasStr1 = !!s1;
  const hasStr2 = !!s2;

  if (!hasStr1 && !hasStr2) return '';
  if (hasStr1 && !hasStr2) return s1;
  if (!hasStr1 && hasStr2) return s2;

  if (s1.toLowerCase() === s2.toLowerCase()) {
    return s1;
  }

  return `${s1}${separator}${s2}`;
}
